import React from "react";
import {observer} from "mobx-react-lite";
import {useAuth} from "../../stores/AuthStore";
import {Redirect, Route} from "react-router-dom";
import AuthRouteProps from "./AuthRouteProps";

const BackofficeRoute:React.FC<AuthRouteProps> = observer(({ children, redirectTo= "/login", ...rest }) => {
  const auth = useAuth();

  if (auth.isAuthenticated && auth.user?.backofficeAccess) {
    return <Route {...rest}>{children}</Route>;
  } else {
    return  <Redirect
      to={{
        pathname: redirectTo,
        state: { from: rest.location }
      }}
    />;
  }
});

export default BackofficeRoute;